import React, { useState, useEffect, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaChevronLeft, FaChevronRight, FaTimes } from "react-icons/fa";
import { GrGallery } from "react-icons/gr";

/* 🔹 Import automatico immagini (CRA / Webpack) */
function importAll(r) {
  return r.keys().map(r);
}

const immagini = importAll(
  require.context("../imgs/Galleria", false, /\.(png|jpe?g|webp)$/),
).sort((a, b) => a.localeCompare(b)); // ordine per nome file

const NewGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [paginaCorrente, setPaginaCorrente] = useState(1);
  const immaginiPerPagina = 12;
  const numeroTotalePagine = Math.ceil(immagini.length / immaginiPerPagina);
  const immaginiCorrenti = useMemo(() => {
    const start = (paginaCorrente - 1) * immaginiPerPagina;
    return immagini.slice(start, start + immaginiPerPagina);
  }, [paginaCorrente]);
  const scrollUp = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  /* 🔹 Precaricamento solo immagini della pagina corrente */
  useEffect(() => {
    const preloadImages = immaginiCorrenti.map((src) => {
      const img = new Image();
      img.src = src;
      return img;
    });
    // cleanup opzionale
    return () => {
      preloadImages.forEach((img) => {
        img.src = "";
      });
    };
  }, [immaginiCorrenti]);
  return (
    <div className="bg-gradient-to-r from-white to-amber-50 min-h-screen flex flex-col items-center pb-10">
      <GrGallery className="fixed text-amber-200/40 text-[180px] rotate-12 -top-5 -right-5 z-0" />
      <h2 className="text-red-600 font-extrabold text-3xl md:text-4xl mt-5 tracking-wide z-10">
        GALLERIA
      </h2>
      {/* 📸 Griglia immagini */}
      <div className="mt-5 px-4 grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 max-w-7xl z-10">
        {immaginiCorrenti.map((immagine, index) => (
          <motion.div
            key={index}
            className="relative overflow-hidden rounded-xl shadow-md cursor-pointer aspect-square"
            whileHover={{ scale: 1.03 }}
            transition={{ duration: 0.3 }}
            onClick={() => setSelectedImage(immagine)}
          >
            <img
              src={immagine}
              alt={`Immagine ${index + 1}`}
              className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
              loading="lazy"
            />
          </motion.div>
        ))}
      </div>
      {/* 🔄 Navigazione pagine */}
      <div className="flex justify-center items-center gap-6 mt-10 z-10">
        <button
          onClick={() => {
            setPaginaCorrente((p) => Math.max(p - 1, 1));
            scrollUp();
          }}
          disabled={paginaCorrente === 1}
          className={`p-3 rounded-full shadow-md transition-all ${
            paginaCorrente === 1
              ? "bg-gray-200 cursor-not-allowed"
              : "bg-red-600 hover:bg-red-700 text-white"
          }`}
        >
          <FaChevronLeft />
        </button>
        <span className="text-gray-600 font-medium text-lg">
          Pagina {paginaCorrente} di {numeroTotalePagine}
        </span>
        <button
          onClick={() => {
            setPaginaCorrente((p) => Math.min(p + 1, numeroTotalePagine));
            scrollUp();
          }}
          disabled={paginaCorrente === numeroTotalePagine}
          className={`p-3 rounded-full shadow-md transition-all ${
            paginaCorrente === numeroTotalePagine
              ? "bg-gray-200 cursor-not-allowed"
              : "bg-red-600 hover:bg-red-700 text-white"
          }`}
        >
          <FaChevronRight />
        </button>
      </div>
      {/* 🌙 Lightbox */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
          >
            <motion.div
              className="relative p-4"
              initial={{ scale: 0.95 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.95 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="absolute top-0 right-0 m-4 bg-white text-red-700 p-2 rounded-full shadow-lg hover:bg-red-100 transition"
                onClick={() => setSelectedImage(null)}
              >
                <FaTimes size={18} />
              </button>
              <img
                src={selectedImage}
                alt="Immagine selezionata"
                className="max-h-[85vh] max-w-[90vw] rounded-lg object-contain"
                loading="lazy"
              />
              <p className="text-white text-sm text-center mt-2">
                Photo by{" "}
                <span className="font-semibold">Alessandro Uttaro</span>
              </p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default NewGallery;
